<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Splash Screens</h4>
          </div>
        </div>
<!--        <ul class="table-top-head">-->

<!--          <li>-->
            <!--            <a-->
            <!--                ref="collapseHeader"-->
            <!--                data-bs-toggle="tooltip"-->
            <!--                data-bs-placement="top"-->
            <!--                title="Collapse"-->
            <!--                @click="toggleCollapse(collapseHeader.value)"-->
            <!--            >-->
            <!--              <i data-feather="chevron-up" class="feather-chevron-up"></i>-->
            <!--            </a>-->
<!--          </li>-->
<!--        </ul>-->
        <div class="page-btn">
          <a
              href="javascript:void(0);"
              class="btn btn-added"
              @click="openModal('new')"
          >
            <vue-feather type="plus-circle" class="me-2"></vue-feather>
            Add Splash Screen
          </a>
        </div>
      </div>
      <!-- SPLASH SCREEN TABLE -->
      <filter-table
          :extra-class="['table', 'datanew']"
          :columns="splashScreen.columns"
          :data="splashScreen.data.value"
          :filters="splashScreen.filters"
      >
        <template #header>
          <h4>Available Splash Screens</h4>
        </template>


        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'image'">
            <div class="">
              <a href="javascript:void(0);" class="">
                <Avatar
                    :src="record.image"
                    :alt="record.title"
                    :shape="shape"
                    img-class="user-image"
                />
              </a>

            </div>
          </template>

          <template v-else-if="column.key === 'status'">
            <a-switch
                :checked="record.status"
                @change="updateSplashScreenStatus(record.id)"
            />
          </template>

          <template v-if="column.key === 'action'">
            <td class="action-table-data">
              <div class="edit-delete-action">
                <a @click="openModal('update', record.id)" class="me-2 p-2 mb-0">
                  <i data-feather="edit" class="feather-edit"></i>
                </a>
                <a
                    @click="deleteSplashScreen(record.id)"
                    class="me-2 confirm-text p-2 mb-0"
                    href="javascript:void(0);"
                >
                  <i data-feather="trash-2" class="feather-trash-2"></i>
                </a>
              </div>
            </td>
          </template>
        </template>

        <!-- </template> -->
      </filter-table>
      <!-- SPLASH SCREEN TABLE -->
    </div>
  </div>

  <SplashScreenModal :splash-screen-id="selectedSplashScreenId" ref="uploadMediaModal"/>


</template>

<script setup>
import SplashScreenModal from "@/views/pages/splashScreen/modal/splash-screen-modal.vue";
import Avatar from "@/components/avatar.vue";
import {confirm} from "@/utils/swal";
import {toggleCollapse} from "@/utils/components";
import {useSplashScreenStore} from "@/store/splashScreenStore";
import {computed, onMounted, ref} from "vue";
import MediaModal from "@/views/pages/mediaLibrary/modal/media-modal.vue";

const splashScreenStore = useSplashScreenStore();

const selectedSplashScreenId = ref(null);

const splashScreen = {
  filters: ["title", "startDate", "endDate"],
  columns: [
    {
      title: "Splash Screen",
      dataIndex: "image",
      key: "image",
    },
    {
      title: "title",
      dataIndex: "title",
      key: "title",
      sorter: {
        compare: (a, b) => {
          a = a.description.toLowerCase();
          b = b.description.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "Start date",
      dataIndex: "startDate",
      key: "startDate",
      sorter: {
        compare: (a, b) => {
          a = a.startDate.toLowerCase();
          b = b.startDate.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },

    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      sorter: {
        compare: (a, b) => {
          a = a.endDate.toLowerCase();
          b = b.endDate.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },

    {
      title: "Is Active",
      dataIndex: "status",
      key: "status",
      sorter: {
        compare: (a, b) => {
          a = a.status.toLowerCase();
          b = b.status.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },

    {
      title: "Action",
      key: "action",
      sorter: true,
    },
  ],
  data: computed(() => splashScreenStore.splashScreen),
};

function openModal(action, id = null) {
  // selectedSplashScreenId.value = null;
  if (action === "update") {
    selectedSplashScreenId.value = id;
  } else {
    selectedSplashScreenId.value = null;
  }
  $("#splashScreenModal").modal("show");
}

async function handlePageChange(newPage) {
  await splashScreenStore.fetchSplashScreen(newPage);
}

async function deleteSplashScreen(id) {
  confirm({
    title: "Are you sure about this?",
    message: "This splash screen will be deleted",
    callback: async (continueDelete) => {
      if (continueDelete) {
        await splashScreenStore.deleteSplashScreen(id);
      }
    },
  });
}

async function updateSplashScreenStatus(id)
{
  await splashScreenStore.updateSplashScreenStatus(id);
}

onMounted(async () => {
  await splashScreenStore.fetchSplashScreen();

  const modalEl = document.getElementById("splashScreenModal");

  modalEl.addEventListener("hidden.bs.modal", async () => {
    await splashScreenStore.fetchSplashScreen();
  });
});


</script>

<style scoped>
.userimgname {
  display: flex;
  align-items: center;
  gap: 12px;
}

.userslist-img {
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>